import { TranslateService } from '@ngx-translate/core';
import { ILogger } from '@nimbus-library/features/logger/services/logger/i-logger';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { LicenseItemDisableReason } from './input-license.model';

/**
 * Builds the tooltip text listing the reasons why a license option is disabled.
 *
 * When `NimbusUnifyServiceLicenseDisabledReason` is among the reasons, the option isn't offered for the
 * Nimbus Unify service at all, so that's the only relevant message - it's shown standalone, without the
 * generic header or any other (irrelevant) reason.
 */
export function buildLicenseDisabledReasonsTooltip(
  disabledReasons: string[],
  translationMapper: Record<string, TranslationKeys>,
  headerTranslationKey: TranslationKeys,
  translateService: TranslateService,
  loggerService: ILogger,
): string | null {
  if (!disabledReasons?.length) {
    return null;
  }

  if (disabledReasons.includes(LicenseItemDisableReason.NIMBUS_UNIFY_SERVICE_LICENSE_DISABLED_REASON)) {
    return translateService.instant(translationMapper[LicenseItemDisableReason.NIMBUS_UNIFY_SERVICE_LICENSE_DISABLED_REASON]);
  }

  let result = `${translateService.instant(headerTranslationKey)}\n`;

  disabledReasons.forEach((key) => {
    if (!translationMapper[key]) {
      loggerService.error(`${key} LicenseDisabledReasons translation is not implemented.`);
      return;
    }

    result += `\n• ${translateService.instant(translationMapper[key])}`;
  });

  return result;
}
